// extracted by mini-css-extract-plugin
export var divider = "_pc-0";
export var systemMessage = "_pc-1";
export var systemMessageWrapper = "_pc-2";